import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getERPStoreDataByDay } from '@/service/erpAPI';

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  data: {
    list: [],
  }
};

export const fetchERPStoreDataByDay = createAsyncThunk(
  'erpStoreDataByDay/fetchERPStoreDataByDay',
  async ({ query = {} }, { rejectWithValue }) => {
    try {
      const response = await getERPStoreDataByDay(query);
      return {
        data: response.data,
        query
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || '获取ERP门店对比数据失败');
    }
  }
);

const erpStoreDataByDaySlice = createSlice({
  name: 'erpStoreDataByDay',
  initialState: defaultState,
  reducers: {
    resetERPStoreDataByDayState: (state) => {
      state.query = {};
      state.data = {};
      state.error = null;
      state.fetching = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchERPStoreDataByDay.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.query = action.meta.arg.query;
      })
      .addCase(fetchERPStoreDataByDay.fulfilled, (state, action) => {
        const { data, query } = action.payload
        state.fetching = false;
        state.error = null;
        state.data = data.data;
        state.query = query;
      })
      .addCase(fetchERPStoreDataByDay.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.data = {};
      });
  }
});

export const { resetERPStoreDataByDayState } = erpStoreDataByDaySlice.actions;
export default erpStoreDataByDaySlice.reducer;
